<template>
  <v-card flat color="transparent" class="mt-n9">
    <v-row class="mt-5">
      <v-col cols="12">
        <v-textarea
          outlined
          filled
          dense
          rows="3"
          no-resize
          :placeholder="$t('장문형 텍스트')"
          v-model="questionAnswer"
          :error-messages="errorMessage"
          :color="themeColor"
          maxlength="500"
        ></v-textarea>
        <span>{{textLenght + " / 500 자"}}</span>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { validate } from "vee-validate";
export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
    },
    isValid: {
      type: Boolean,
      default: false,
    },
    themeColor: {
      type: String,
      default: "primary",
    },
    responseAnswer: Object,
  },
  computed: {
    textLenght(){
      let t = this.questionAnswer?this.questionAnswer.length:0;
      return t;
    },
    questionAnswers() {
      let qa = null;
      if (this.questionAnswer != null) {
        qa = [this.questionAnswer];
      } else {
        qa = [];
      }
      return {
        questionId: this.question.questionId,
        questionMatrixId: null,
        questionAnswerVals: qa,
        questionType: this.question.questionType,
      };
    },
  },
  data() {
    return {
      questionAnswer: null,
      validationOptions: JSON.parse(this.question.validationOptions),
      errorMessage: [],
    };
  },
  methods: {
    async checkValidation() {
      let rules = {};

      if (this.question.required) {
        rules["required"] = true;
      }
      if (this.validationOptions) {
        const textType = this.validationOptions.textType;
        if (
          textType == "TEXT" &&
          this.validationOptions.lengthValidType &&
          this.validationOptions.limitLength
        ) {
          switch (this.validationOptions.lengthValidType) {
            case "LIMIT_MIN_LENGTH":
              rules["min"] = this.validationOptions.limitLength;
              break;
            case "LIMIT_MAX_LENGTH":
              rules["max"] = this.validationOptions.limitLength;
              break;
            case "LIMIT_FIX_LENGTH":
              rules["length"] = this.validationOptions.limitLength;
              break;
            default:
              break;
          }
        }
      }
      let rst = await validate(this.questionAnswer, rules, { name: "이 " });
      this.$emit("update:isValid", rst.valid);
      this.errorMessage = rst.errors;
    },
    setQuestionAnswer() {
      this.questionAnswer =
        this.responseAnswer.response && this.responseAnswer.response.length > 0
          ? this.responseAnswer.response[0].answerVal
          : null;
    },
  },
  watch: {
    async questionAnswer() {
      await this.checkValidation();
      this.$emit("input", this.questionAnswers);
    },
  },
  mounted() {
    if (this.responseAnswer) {
      this.setQuestionAnswer();
    }
    this.$emit("input", this.questionAnswers);
  },
};
</script>

<style></style>
